(() => {
  const root = document.documentElement;
  const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const observer = "IntersectionObserver" in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.dataset.visible = "true";
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -7%" }) : null;

  const reveal = (scope = document) => {
    scope.querySelectorAll("[data-reveal]").forEach((node) => {
      if (motion.matches || !observer) node.dataset.visible = "true";
      else if (node.dataset.visible !== "true") observer.observe(node);
    });
    root.dataset.revealReady = "true";
  };

  const initialize = () => {
    if (!document.querySelector("enso-signal")) root.dataset.signalReady = "true";
    reveal();
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialize, { once: true });
  else initialize();

  motion.addEventListener("change", () => {
    if (motion.matches) observer?.disconnect();
    reveal();
  });
  document.addEventListener("shopify:section:load", (event) => reveal(event.target));
  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll("[data-reveal]").forEach((node) => observer?.unobserve(node));
  });
  document.addEventListener("shopify:section:select", (event) => {
    event.target.querySelectorAll("[data-reveal]").forEach((node) => {
      node.dataset.visible = "true";
      observer?.unobserve(node);
    });
  });
  document.addEventListener("focusin", (event) => {
    const node = event.target.closest("[data-reveal]");
    if (node) {
      node.dataset.visible = "true";
      observer?.unobserve(node);
    }
  });
})();
